import React from 'react';
import { useTranslation } from 'react-i18next';
import { Eye, EyeOff } from 'lucide-react';
import { validateIpePassword } from '@/utils/ipePasswordValidation';

export default function AuthPasswordFields({
  password,
  confirmPassword,
  onPasswordChange,
  onConfirmChange,
  showPassword,
  onToggleShowPassword,
  disabled = false,
  submitAttempted = false,
  onPasswordBlur,
  onConfirmBlur,
  passwordPlaceholder,
  confirmPlaceholder,
}) {
  const { t } = useTranslation('login');
  const passwordHintText = passwordPlaceholder || t('auth.setPassword');
  const confirmHintText = confirmPlaceholder || t('auth.confirmPassword');
  const passwordHint = (() => {
    if (password.length > 0) {
      return validateIpePassword(password);
    }
    if (submitAttempted) {
      return validateIpePassword(password);
    }
    return null;
  })();

  const confirmHint =
    confirmPassword.length > 0 && password !== confirmPassword
      ? t('auth.passwordMismatch')
      : null;

  return (
    <>
      <div className="ipe-auth-modal__field-block">
        <div className="ipe-auth-modal__field ipe-auth-modal__field--password">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder={passwordHintText}
            value={password}
            onChange={(e) => onPasswordChange(e.target.value)}
            onBlur={onPasswordBlur}
            disabled={disabled}
            autoComplete="new-password"
          />
          <button
            type="button"
            className="ipe-login-form__password-toggle"
            onClick={onToggleShowPassword}
            aria-label={showPassword ? t('auth.hidePassword') : t('auth.showPassword')}
            tabIndex={-1}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
        {passwordHint ? (
          <p className="ipe-auth-modal__field-hint ipe-auth-modal__field-hint--error" role="alert">
            {passwordHint}
          </p>
        ) : null}
      </div>

      <div className="ipe-auth-modal__field-block">
        <div className="ipe-auth-modal__field ipe-auth-modal__field--password">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder={confirmHintText}
            value={confirmPassword}
            onChange={(e) => onConfirmChange(e.target.value)}
            onBlur={onConfirmBlur}
            disabled={disabled}
            autoComplete="new-password"
          />
        </div>
        {confirmHint ? (
          <p className="ipe-auth-modal__field-hint ipe-auth-modal__field-hint--error" role="alert">
            {confirmHint}
          </p>
        ) : null}
      </div>
    </>
  );
}

export function isPasswordFormValid(password, confirmPassword) {
  if (validateIpePassword(password)) return false;
  if (password !== confirmPassword) return false;
  return true;
}
